// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTheme } from '@mui/material';

import Tile, { TileProps } from '@components/Timeline/Tile/Tile';
import TileIconAuto from '@components/Timeline/Tile/TileIconAuto';

// TYPES ---------------------------------------------------------------- //

export interface AutoRideProps
  extends Omit<
    TileProps,
    'color' | 'extraWidthBeforeLabel' | 'extraWidthBetweenLabel' | 'extraWidthAfterLabel' | 'secondaryIcon' | 'variant'
  > {}

// COMPONENT ---------------------------------------------------------------- //

const AutoRide = ({ ...props }: AutoRideProps) => {
  const theme = useTheme();

  return (
    <Tile
      color={theme.palette.auto.main}
      extraWidthBeforeLabel={`WAIT`}
      extraWidthBetweenLabel={`???`}
      extraWidthAfterLabel={`RIDE`}
      secondaryIcon={<TileIconAuto />}
      variant={`outlined`}
      {...props}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default AutoRide;
